import React, { useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { ProgressBar } from 'primereact/progressbar'
import { Mention } from 'primereact/mention'
import { Calendar } from 'primereact/calendar'
import { OverlayPanel } from 'primereact/overlaypanel'
import { MultiSelect } from 'primereact/multiselect'
import { Avatar } from 'primereact/avatar'
import FlexComponent from '../../FlexComponent'
import '../apps.css'
import axios from '../../../utils/axios';
import { createCheckList, createAppDoc, deleteCheckList, downloadFilesZip, getChecklistSuggestions, sendChecklistToContact, sendInternalChecklistNotification, updateCheckList, updateCheckListOrder } from '../../../utils/urls'
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable'
import CheckListItem from './CheckListItem'
import { Tooltip } from 'primereact/tooltip'
import { FileUpload } from 'primereact/fileupload'
import AppModal from '../../../shared/AppModal'
import PreviewFile from './PreviewFile'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';


function CheckList({ userId, formId, usersList, salesUsersList, pipelineId, checkListsData, handleUpdateCheckList, handleDeleteCheckList, checkListHeading, handleClose, toast }) {
    // console.log("checkListsData", checkListsData)
    const [checkLists, setCheckLists] = useState(checkListsData.items);
    // const [salesMembersList, setSalesMembersList] = useState(salesUsersList.filter((user)=> (user.roles.includes("contact_owner"))))
    const [salesMembersList, setSalesMembersList] = useState(
        salesUsersList
            .filter(user => !user.roles.includes("application_by"))
            .map(user => ({ label: user.name, value: user.id, image: user.image }))
    );

    const [suggestions, setSuggestions] = useState([]);
    const checklistNotifyOp = useRef(null)
    const checklistContactOp = useRef(null)
    const [isEditTitle, setIsEditTitle] = useState(false)
    const [editTitle, setEditTitle] = useState(checkListHeading)
    const [toggle, setToggle] = useState(false)

    const [isCheckListAdd, setIsCheckListAdd] = useState(false)
    const [value, setValue] = useState('');
    const [mentionedUsers, setMentionedUsers] = useState([]);
    const [assignedUsers, setAssignedUsers] = useState([])
    const [dueDate, setDueDate] = useState('')
    const [checkListEditIndex, setCheckListEditIndex] = useState(null);
    const [selectedSalesUsers, setSelectedSalesUsers] = useState([])
    const [selectedContactUsers, setSelectedContactUsers] = useState([]);
    const [zipFileLoading, setZipFileLoading] = useState(false)

    const [isCheckListEdit, setIsCheckListEdit] = useState(false);

    const [hideCheckedItems, setHideCheckedItems] = useState(true)

    const [checkListLoad, setCheckListLoad] = useState(false)
    const checkedCount = checkLists.filter(list => list.completed).length;

    const [files, setFiles] = useState([]);
    const fileUploadRef = useRef(null);
    const [showFilesPopup, setShowFilesPopup] = useState(false);
    const [loading, setloading] = useState(false)

    const [showSuggestions, setShowSuggestions] = useState(false);
    const [activeWord, setActiveWord] = useState('');
    const [triggerType, setTriggerType] = useState(null); // 'user' | 'suggestion'
    const debounceRef = useRef(null);

    const dueDateOp = useRef(null);
    const assignOp = useRef(null);


    const handleAddCheckList = () => {
        setIsCheckListAdd(true)
        setIsCheckListEdit(false)
    }

    const allFiles = checkLists.flatMap((checklist) =>
        (checklist.file_url || []).map((file) => ({
            ...file,
            checklistItem: checklist.item
        }))
    );

    // console.log("allFiles", allFiles);


    const convertDateToDateString = (date) => {
        if (!date) return '';
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };

    // console.log("salesMembersList", salesMembersList)

    const fetchChecklistSuggestions = async (query = '') => {
        try {
            let url = `${getChecklistSuggestions}?limit=10`;

            if (query) {
                url += `&search=${query}`;
            }

            const res = await axios.get(url);

            if (res.status === 200) {
                const formatted = res.data.results.map(item => ({
                    label: item.name,
                    value: item.name,
                    type: 'suggestion'
                }));

                setSuggestions(formatted);
            }
        } catch (err) {
            console.error(err);
        }
    };


    const onSearch = (event) => {
        const { query, trigger } = event;

        if (trigger === '@') {
            setTriggerType('user');

            const filteredUsers = usersList.filter((user) =>
                user.label.toLowerCase().includes(query.toLowerCase())
            );

            setSuggestions(filteredUsers);
        }
    };

    const handleSuggestionClick = (item) => {
        // Remove mentions temporarily
        const cleaned = value.replace(/@[\w.-]+/g, '').trim();

        const mentions = value.match(/@[\w.-]+/g) || [];

        const newValue = [
            ...mentions,
            item.label
        ].join(' ');

        setValue(newValue + ' ');
        setShowSuggestions(false);
    };


    const onChange = (e) => {
        const inputValue = e.target.value;
        setValue(inputValue);
        setMentionedUsers(extractUsers(inputValue));

        const lastWord = inputValue.split(' ').pop();

        if (lastWord.startsWith('@')) {
            setShowSuggestions(false);
            return;
        }

        const query = inputValue.trim();

        clearTimeout(debounceRef.current);

        if (query.length > 0 && !query.includes("@")) {
            debounceRef.current = setTimeout(() => {
                fetchChecklistSuggestions(query);
                setShowSuggestions(true);
            }, 300);
        } else {
            setShowSuggestions(false);
        }
    };



    const extractUsers = (text) => {
        // Update the regex pattern to match @mentions with periods, underscores, and hyphens
        const mentionPattern = /@([\w.-]+)/g;
        const mentions = [...text.matchAll(mentionPattern)].map(match => match[1]);
        return mentions.map(mention => {
            const user = usersList.find(user => user.label.replace(/\s+/g, '').toLowerCase() === mention.toLowerCase());
            return user ? { id: user.value } : null;
        }).filter(user => user !== null);
    };

    const itemTemplate = (suggestion) => {
        return (
            <div className="flex align-items-center">
                <span className="flex flex-column ml-2">
                    {suggestion.label}
                </span>
            </div>
        );
    };

    const userTemplate = (option) => {
        return (
            <FlexComponent justifyContent="start">
                <Avatar image={option.image} size="small" label={getInitials(option?.label)} shape="circle" style={{ marginRight: '8px' }} />
                <span>{option.label}</span>
            </FlexComponent>
        );
    };

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    const convertDateToString = (date) => {
        if (!date) return ""
        const validDate = date instanceof Date && !isNaN(date) ? date : ""; // Ensure valid Date object
        const year = validDate.getFullYear();
        const month = String(validDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
        const day = String(validDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const handleSaveCheckList = async () => {
        setloading(true);
        setCheckListLoad(true);
        try {
            // Step 1: upload new files to /api/app-docs/
            let newAppDocIds = [];
            if (files.length > 0) {
                const uploaded = await Promise.all(
                    files.map(f => {
                        const fdDoc = new FormData();
                        fdDoc.append('app_id', formId);
                        fdDoc.append('file', f.file);
                        fdDoc.append('file_name', f.editedName);
                        return axios.post(createAppDoc, fdDoc, { headers: { 'Content-Type': 'multipart/form-data' } })
                            .then(r => r.data);
                    })
                );
                newAppDocIds = uploaded.map(d => d.app_doc_id);
            }

            // Step 2: create the checklist item (no file fields)
            const formData = new FormData();
            formData.append('item', value);
            formData.append('due_date', convertDateToString(dueDate));
            formData.append('heading_id', checkListsData.id);
            formData.append('mention', JSON.stringify(mentionedUsers));
            formData.append('assigned_user', JSON.stringify(assignedUsers.map(item => ({ id: item }))));

            const createRes = await axios.post(`${createCheckList}${formId}/${userId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (createRes.status !== 200) throw new Error('Create failed');

            const newChecklistId = createRes.data.checklist_id;
            let fileUrlResult = createRes.data.file_url || [];

            // Step 3: if files were uploaded, assign them via updateCheckList
            if (newAppDocIds.length > 0) {
                const fdUpdate = new FormData();
                fdUpdate.append('item', value);
                fdUpdate.append('due_date', convertDateToString(dueDate));
                fdUpdate.append('is_completed', false);
                fdUpdate.append('mention', JSON.stringify(mentionedUsers));
                fdUpdate.append('assigned_user', JSON.stringify(assignedUsers.map(item => ({ id: item }))));
                fdUpdate.append('removed_file_ids', JSON.stringify([]));
                fdUpdate.append('renamed_files', JSON.stringify([]));
                fdUpdate.append('app_doc_ids', JSON.stringify(newAppDocIds));
                const updateRes = await axios.post(`${updateCheckList}${newChecklistId}/${userId}`, fdUpdate, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (updateRes.status === 200) fileUrlResult = updateRes.data.file_url || [];
            }

            setCheckLists(prev => [...prev, {
                checklist_id: newChecklistId,
                item: value,
                mention: mentionedUsers,
                assigned_user: assignedUsers.map(id => ({ id })),
                due_date: convertDateToString(dueDate),
                file_url: fileUrlResult,
            }]);
            setCheckListLoad(false);
            setValue('');
            setMentionedUsers([]);
            setAssignedUsers([]);
            setDueDate('');
            setFiles([]);
            setloading(false);
            if (fileUploadRef?.current) fileUploadRef.current.clear();
        } catch {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            handleClose();
            setloading(false);
            setCheckListLoad(false);
        }
    };


    function getNameById(id) {
        const item = usersList.find(obj => obj.value === id);
        return item ? item.label : null; // Return the name if found, otherwise return null
    }

    // console.log(checkListsData)

    const calculateCompletionPercentage = () => {
        const total = checkLists.length;
        const completedCount = checkLists.filter(list => list.completed).length;
        const percentage = (completedCount / total) * 100;
        return Math.round(percentage);
    };

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor)
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        // console.log(active, over)
        if (active.id !== over.id) {
            setCheckLists((items) => {
                const oldIndex = items.findIndex(item => item.checklist_id === active.id);
                const newIndex = items.findIndex(item => item.checklist_id === over.id);

                // Move the items in the array
                const newItems = arrayMove(items, oldIndex, newIndex);
                const order = newItems.map(item => item.checklist_id);
                // console.log(order)
                updateChecklistOrderFn(order)
                // Update the position field
                return newItems.map((item, index) => ({
                    ...item,
                    position: index + 1 // assuming position is 1-based
                }));
            });
        }
    };

    const updateChecklistOrderFn = async (order) => {
        try {
            const data = {
                heading_id: checkListsData.id,
                order: order
            }
            const response = await axios.post(updateCheckListOrder, data);
            if (response.status === 200) {
                console.log('Order updated successfully');
            } else {
                console.error('Failed to update order');
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    };

    const sendChecklistNotification = async () => {
        try {

            const data = {
                checklist_heading_id: checkListsData.id,
                sales_users: selectedSalesUsers,
                pipeline_id: pipelineId,
                userId: userId
            }
            console.log(data)
            const response = await axios.post(sendInternalChecklistNotification, data);
            if (response.status === 200) {
                // console.log('Order updated successfully');
                toast.current.show({ severity: 'success', summary: '', detail: 'Success', life: 3000 });

            } else {
                console.error('Failed to update order');
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    };

    const sendChecklistToContactFn = async () => {
        try {
            const data = {
                checklist_heading_id: checkListsData.id,
                sales_users: selectedContactUsers,
                pipeline_id: pipelineId,
                userId: userId
            }
            console.log(data)
            const response = await axios.post(sendChecklistToContact, data);
            if (response.status === 200) {
                // console.log('Order updated successfully');
                toast.current.show({ severity: 'success', summary: '', detail: 'Success', life: 3000 });

            } else {
                console.error('Failed to update order');
            }
        } catch (error) {
            console.error('Error updating order:', error);
        }
    };

    // console.log(hideCheckedItems)

    // const userTemplate = (option) => {
    //     return (
    //         <FlexComponent justifyContent="start">
    //             <Avatar image={option.image} size="small" label={<span style={{ padding: '5px' }}>{getInitials(option?.label)}</span>} shape="circle" style={{ marginRight: '8px' }} />
    //             <span>{option.label}</span>
    //         </FlexComponent>
    //     );
    // };

    // const handleDownload = (file) => {
    //     const link = document.createElement('a');
    //     link.href = file.file_url;
    //     link.download = file.file_name;        // This forces download with original name
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    const handleDownload = async (file) => {
        try {
            const response = await axios.get(file.file_url, { responseType: 'blob' });
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.file_name || 'downloaded-file';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            window.open(file.file_url, "_blank");
        }
    };

    const handleDownloadAllAsZip = async () => {
        if (allFiles.length === 0) return;

        try {
            setZipFileLoading(true)
            const fileIds = allFiles.map(file => file.id);

            const response = await axios.post(downloadFilesZip, {
                files: fileIds
            }, {
                responseType: 'blob'
            });

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            const fileName = `${checkListHeading.replace(/[^a-zA-Z0-9]/g, '_')}_files.zip`;

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // toast.current?.show({
            //     severity: 'success',
            //     summary: 'Download Started',
            //     detail: 'ZIP file downloaded successfully',
            //     life: 3000
            // });
            setZipFileLoading(false)
        } catch (err) {
            console.error('ZIP Download Error:', err);
            toast.current?.show({
                severity: 'error',
                summary: 'Download Failed',
                detail: err.response?.data?.message || 'Failed to download ZIP file',
                life: 4000
            });
            setZipFileLoading(false)
        }
    };

    return (
        <div className='checkListDiv' style={{ marginTop: "1rem" }} >
            {/* <span style={{ cursor: "pointer" }} >⣿</span> */}
            <FlexComponent gap="1rem" className="checkListSectionDiv" >
                {!isEditTitle ?
                    <FlexComponent justifyContent="start" gap="1rem" >
                        <p><span style={{ marginLeft: "1rem" }} >{checkListHeading}</span> </p>
                        <i style={{ cursor: "pointer" }} onClick={() => {
                            setIsEditTitle(!isEditTitle)
                        }} className='pi pi-pencil'></i>
                    </FlexComponent> :
                    <FlexComponent justifyContent="start" gap="1rem" >
                        <InputText style={{ padding: ".3rem" }} id="title" value={editTitle} onChange={(e) => {
                            setEditTitle(e.target.value)
                        }} />
                        <i style={{ cursor: "pointer" }} onClick={() => {
                            handleUpdateCheckList(editTitle, checkListsData.id)
                            setIsEditTitle(!isEditTitle)
                        }} className='pi pi-save'></i>
                    </FlexComponent>
                }
                <FlexComponent justifyContent="end" gap=".5rem" style={{ paddingRight: "1rem" }} >


                    <Button icon='pi pi-address-book'
                        tooltip="Send email to Client" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                        onClick={(e) => {
                            checklistContactOp.current.toggle(e)
                        }} style={{ color: "white", boxShadow: "none", padding: "0.3rem .6rem", border: "1px solid grey", fontSize: "14px" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='white' width="24" height="24" viewBox="0 0 24 24">
                            <path d="M22 4v16h-1.537c-.692-1.195-1.985-2-3.463-2s-2.771.805-3.463 2h-3.074c-.692-1.195-1.985-2-3.463-2s-2.771.805-3.463 2h-1.537v-16h20zm2-2h-24v20h5c0-1.104.896-2 2-2s2 .896 2 2h6c0-1.104.896-2 2-2s2 .896 2 2h5v-20zm-10 13.597v.403h-10v-.417c-.004-1.112.044-1.747 1.324-2.043 1.402-.324 2.787-.613 2.121-1.841-1.972-3.637-.562-5.699 1.555-5.699 2.077 0 3.521 1.985 1.556 5.699-.647 1.22.688 1.51 2.121 1.841 1.284.297 1.328.936 1.323 2.057zm6-9.597h-4v2h4v-2zm0 4h-4v2h4v-2zm0 4h-4v2h4v-2z" />
                        </svg></Button>

                    <Tooltip mouseTrack mouseTrackLeft={10} />

                    {/* <i class="text-2xl mb-3 text-color-secondary pi pi-address-book"></i> */}
                    <Button icon="pi pi-user"
                        tooltip="Send SMS to sales rep" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
                        onClick={(e) => {
                            checklistNotifyOp.current.toggle(e)
                        }} style={{ boxShadow: "none", padding: "0.5rem 1rem", border: "1px solid grey", fontSize: "14px" }}></Button>


                    <OverlayPanel ref={checklistNotifyOp} style={{ background: "#254270" }} >

                        <FlexComponent justifyContent="center" gap=".5rem" style={{ marginTop: ".5rem" }}>
                            <MultiSelect
                                value={selectedSalesUsers}
                                options={usersList}
                                itemTemplate={userTemplate}
                                style={{ maxWidth: '275px', color: 'black' }}
                                onChange={(event) => {
                                    setSelectedSalesUsers(event.value)
                                    // setLoading(true)
                                }}
                                placeholder='Select Users'
                                filter
                            />
                            <Button style={{ boxShadow: "none", padding: "0.4rem 1.4rem 0.4rem 1rem", border: "1px solid grey" }}
                                disabled={selectedSalesUsers.length === 0} onClick={(e) => {
                                    sendChecklistNotification()
                                    checklistNotifyOp.current.toggle(e)
                                    setSelectedSalesUsers([])
                                }}>Submit </Button>
                        </FlexComponent>

                    </OverlayPanel>

                    <OverlayPanel ref={checklistContactOp} style={{ background: "#254270" }} >

                        <FlexComponent justifyContent="center" gap=".5rem" style={{ marginTop: ".5rem" }}>
                            <MultiSelect
                                value={selectedContactUsers}
                                options={usersList}
                                itemTemplate={userTemplate}
                                style={{ maxWidth: '275px', color: 'black' }}
                                onChange={(event) => {
                                    setSelectedContactUsers(event.value)
                                    // setLoading(true)
                                }}
                                placeholder='Select Users'
                                filter
                            />
                            <Button style={{ boxShadow: "none", padding: "0.4rem 1.4rem 0.4rem 1rem", border: "1px solid grey" }}
                                disabled={selectedContactUsers.length === 0}
                                onClick={(e) => {
                                    sendChecklistToContactFn()
                                    checklistContactOp.current.toggle(e)
                                    setSelectedContactUsers([])
                                }}>Submit </Button>
                        </FlexComponent>

                    </OverlayPanel>
                    <Button style={{ boxShadow: "none", padding: "0.5rem 1rem", border: "1px solid grey", fontSize: "14px" }} onClick={() => {
                        setHideCheckedItems(!hideCheckedItems)
                    }}
                    >{hideCheckedItems ? `Show Checked Items (${checkedCount})` : 'Hide Checked Items'}</Button>

                    <i style={{ cursor: "pointer" }} onClick={() => {
                        handleDeleteCheckList(checkListsData.id)
                    }} className='pi pi-trash'></i>

                    <i style={{ cursor: "pointer" }} onClick={() => {
                        setToggle(!toggle)
                    }} className={toggle ? 'pi pi-plus' : 'pi pi-minus'}></i>

                </FlexComponent>
            </FlexComponent>
            <FlexComponent style={{ padding: "0 1rem", marginTop: ".5rem" }} gap="1rem" >
                <div className="card" style={{ borderRadius: "20px", marginTop: "0.5rem" }} >
                    <ProgressBar value={calculateCompletionPercentage()}></ProgressBar>
                </div>
                {allFiles?.length > 0 && <FlexComponent style={{ width: "auto" }} gap=".5rem" >
                    <Button
                        label='Files'
                        icon="pi pi-eye"
                        style={{ width: "70px", padding: "5px", border: "1px solid grey" }}
                        onClick={() => setShowFilesPopup(true)}
                    />

                    <Button
                        label='Zip'
                        icon="pi pi-download"
                        style={{
                            padding: "5px",
                            border: "1px solid grey",
                            width: "60px"
                        }}
                        loading={zipFileLoading}
                        onClick={handleDownloadAllAsZip}
                    />
                </FlexComponent>
                }
            </FlexComponent>
            <div style={{ marginTop: ".5rem", display: toggle ? "none" : "" }} >
                <div >
                    <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                    >
                        <SortableContext items={checkLists.map(item => item.checklist_id)} strategy={verticalListSortingStrategy}>
                            {checkLists.map((list, index) => (
                                <div key={index} style={{marginLeft: "1rem", marginTop: ".5rem"}} >
                                    {(!hideCheckedItems || !list.completed) && <CheckListItem list={list} index={index} usersList={usersList} convertDateToString={convertDateToString} getNameById={getNameById}
                                        userTemplate={userTemplate} getInitials={getInitials} itemTemplate={itemTemplate} setIsCheckListEdit={setIsCheckListEdit} setCheckLists={setCheckLists}
                                        setIsCheckListAdd={setIsCheckListAdd} updateCheckList={updateCheckList} userId={userId} formId={formId} toast={toast} handleClose={handleClose} setValue={setValue}
                                        setMentionedUsers={setMentionedUsers} setAssignedUsers={setAssignedUsers} setDueDate={setDueDate} checkLists={checkLists} suggestions={suggestions}
                                        onSearch={onSearch} convertDateToDateString={convertDateToDateString} hideCheckedItems={hideCheckedItems} isCheckListEdit={isCheckListEdit}
                                        checkListEditIndex={checkListEditIndex} setCheckListEditIndex={setCheckListEditIndex}
                                    />
                                    }
                                </div>
                            ))}
                        </SortableContext>
                    </DndContext>
                </div>
                {!isCheckListAdd &&  <Button onClick={handleAddCheckList} style={{marginLeft: "1rem", marginTop: ".5rem", padding: "0.4rem 1rem", border: "1px solid grey" }}>Add an Item</Button>}
                {isCheckListAdd && <div style={{ padding: "1rem ", border: "1px solid grey", marginTop: ".5rem", borderRadius: "10px", marginLeft: "1rem" }} >
                    
                        <div style={{ position: "relative" }}  >
                            {/* <Mention
                                value={value}
                                onChange={onChange}
                                suggestions={suggestions}
                                onSearch={onSearch}
                                field="label"
                                placeholder="Add an Item"
                                // rows={1}
                                // cols={50}
                                itemTemplate={itemTemplate}
                                style={{ width: "100%" }}
                                className="mention-input"
                            /> */}
                            <Mention
                                value={value}
                                onChange={onChange}
                                suggestions={suggestions}
                                onSearch={onSearch}
                                field="label"
                                trigger={['@']}
                                placeholder="Add an Item"
                                itemTemplate={itemTemplate}
                                style={{ width: "100%" }}
                                className="mention-input"
                            />

                            {showSuggestions && suggestions.length > 0 && !value.includes("@") && (
                                <div className="custom-suggestion-dropdown">
                                    {suggestions.map((item, index) => (
                                        <div
                                            key={index}
                                            className="suggestion-item"
                                            onClick={() => handleSuggestionClick(item)}
                                        >
                                            <i className="pi pi-list" style={{ marginRight: '8px' }}></i>
                                            {item.label}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {files.length > 0 && (
                                <div style={{ marginTop: "8px" }}>
                                    {files.map((item, index) => (
                                        <FlexComponent key={index} justifyContent="space-between" style={{ marginTop: "5px", maxWidth: "400px", padding: "5px", border: "1px solid grey", marginTop: "3px", borderRadius: "5px" }} >
                                            <div style={{ width: "100%" }}>
                                                <i className="pi pi-folder" />

                                                <input
                                                    type="text"
                                                    value={item.editedName}
                                                    onChange={(e) => {
                                                        const updatedFiles = [...files];

                                                        updatedFiles[index].editedName = e.target.value;

                                                        setFiles(updatedFiles);
                                                    }}
                                                    style={{
                                                        marginLeft: ".5rem",
                                                        fontSize: "14px",
                                                        width: "250px"
                                                    }}
                                                />
                                            </div>
                                            <i
                                                className="pi pi-trash"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setFiles(prev => prev.filter((_, i) => i !== index));

                                                    if (fileUploadRef.current) {
                                                        fileUploadRef.current.clear();
                                                    }
                                                }}
                                            />
                                        </FlexComponent>
                                    ))}
                                </div>
                            )}

                            <FlexComponent className="addChecklistSectionSection"  >

                                <FlexComponent justifyContent="center" gap="1rem" className="assignDueDateChecklist" style={{ marginTop: ".5rem" }} >

                                    {/* <FlexComponent>
                                        <FileUpload
                                            ref={fileUploadRef}
                                            mode="basic"
                                            name="files"
                                            multiple
                                            accept="*"
                                            maxFileSize={10000000}
                                            customUpload
                                            auto={false}
                                            chooseLabel={files.length > 0 ? `${files.length} file(s) selected` : "Add Files"}
                                            onSelect={(e) => {
                                                const selectedFiles = e.files;

                                                const mappedFiles = selectedFiles.map(file => ({
                                                    file,
                                                    editedName: file.name
                                                }));

                                                setFiles(prev => [...prev, ...mappedFiles]);
                                                if (fileUploadRef.current) {
                                                    fileUploadRef.current.clear();
                                                }
                                            }}
                                        />
                                    </FlexComponent> */}

                                    <FlexComponent style={{ border: "none", boxShadow: "none" }} justifyContent="start" >
                                        <span onClick={(e) => assignOp.current.toggle(e)} style={{ cursor: "pointer" }} ><i className="pi pi-user-plus" style={{ marginRight: '5px' }}></i>
                                            {assignedUsers.length > 0 ? (
                                                <>
                                                    {assignedUsers.map((id, index) => (
                                                        <span key={index}>
                                                            {index == 0 && <span >{getNameById(id)}</span>}
                                                        </span>
                                                    ))}
                                                    {assignedUsers.length > 1 && <span style={{ marginLeft: ".2rem", padding: ".2rem", background: "white", color: "black", borderRadius: "25px" }}>+{assignedUsers.length - 1}</span>}
                                                </>
                                            ) :
                                                <span >Assign</span>}
                                        </span>
                                    </FlexComponent>
                                    <FlexComponent style={{ border: "none", boxShadow: "none" }} justifyContent="start" >
                                        <span style={{ cursor: "pointer" }}
                                            onClick={(e) => dueDateOp.current.toggle(e)}
                                        ><i className="pi pi-clock" style={{ marginRight: '5px' }}></i>
                                            {dueDate ? <span>{convertDateToDateString(dueDate)}</span> : <span>Due Date</span>}
                                        </span>
                                    </FlexComponent>
                                </FlexComponent>

                            </FlexComponent>
                            <FileUpload
                                ref={fileUploadRef}
                                name="files"
                                multiple
                                accept="*"
                                maxFileSize={30000000}
                                customUpload
                                auto={false}
                                mode="advanced"
                                chooseLabel=""                    // Hide browse button text
                                uploadLabel=""                    // Hide upload button
                                cancelLabel=""                    // Hide cancel button
                                emptyTemplate={
                                    <div
                                        style={{
                                            padding: "1rem",
                                            marginTop: ".75rem",
                                            textAlign: "center",
                                            color: "#999",
                                            border: "2px dashed #666",
                                            borderRadius: "10px",
                                            cursor: "pointer",
                                            // background: "#f8f9fa",
                                            transition: "all 0.2s"
                                        }}
                                        onClick={() => fileUploadRef.current?.getInput().click()} // Make whole area clickable
                                    >
                                        <i
                                            className="pi pi-cloud-upload"
                                            style={{ fontSize: "2.5rem", marginBottom: "12px", color: "#606160" }}
                                        />
                                        <p style={{ margin: "0 0 8px 0", fontSize: "15px" }}>
                                            Drag and drop files here
                                        </p>
                                        <small style={{ color: "#666" }}>
                                            or <strong style={{ color: "#606160" }}>click to browse</strong>
                                        </small>
                                    </div>
                                }
                                onSelect={(e) => {
                                    const selectedFiles = e.files;

                                    const mappedFiles = selectedFiles.map(file => ({
                                        file,
                                        editedName: file.name
                                    }));

                                    setFiles(prev => [...prev, ...mappedFiles]);

                                    // Clear immediately so duplicate uploads don't show in default UI
                                    setTimeout(() => {
                                        fileUploadRef.current?.clear();
                                    }, 100);
                                }}
                                style={{
                                    width: "100%",
                                    // maxWidth: "400px"
                                }}
                            />


                            <OverlayPanel ref={assignOp} style={{ background: '#1A2B53', maxWidth: "400px" }} showCloseIcon>
                                <MultiSelect
                                    value={assignedUsers}
                                    options={usersList}
                                    itemTemplate={userTemplate}
                                    style={{ width: '100%', color: 'black' }}
                                    onChange={(event) => {
                                        setAssignedUsers(event.value);
                                    }}
                                    placeholder='Select Members'
                                    filter
                                />
                            </OverlayPanel>
                            <OverlayPanel ref={dueDateOp} style={{ background: '#1A2B53' }} >
                                <Calendar id="buttondisplay" value={dueDate} inline onChange={(e) => {
                                    setDueDate(e.value)
                                    dueDateOp.current.toggle(e)
                                }} />
                            </OverlayPanel>
                        </div>
                    
                </div>}

                {isCheckListAdd && <FlexComponent gap="0.5rem" justifyContent="start" className="addCancelChecklist" style={{ width: "55%", marginTop: ".5rem", marginLeft: "1rem" }} >
                    <Button loading={loading} disabled={!value} style={{ padding: "0.4rem 1rem", background: "#2FC635", border: "1px solid grey" }} onClick={() => {
                        handleSaveCheckList()
                    }} >Add</Button>
                    <Button style={{ padding: "0.4rem 1rem", border: "1px solid grey" }} onClick={() => {
                        setIsCheckListAdd(false)
                        setAssignedUsers([])
                        setValue('')
                        setDueDate('')

                        setFiles([]);
                        if (fileUploadRef?.current) {
                            fileUploadRef.current.clear();
                        }
                    }} >Cancel</Button>
                </FlexComponent>}

                <AppModal
                    header={`${checkListHeading} (${allFiles.length})`}
                    visible={showFilesPopup}
                    panelStyle={{ width: "70vw", minHeight: "95vh" }}
                    onHide={() => setShowFilesPopup(false)}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            // maxHeight: "70vh",
                            overflowY: "auto"
                        }}
                    >
                        {allFiles.length === 0 ? (
                            <p>No files found</p>
                        ) : (
                            allFiles?.map((file, index) => (
                                <div style={{
                                    border: "1px solid grey",
                                    borderRadius: "5px",
                                    padding: "0 10px",
                                    marginTop: ".5rem"
                                }}>
                                    <FlexComponent
                                        key={index}
                                        justifyContent="start"
                                        alignItems="center"

                                    >
                                        <FlexComponent
                                            justifyContent="start"
                                            gap=".7rem"
                                            style={{ width: "auto" }}
                                        >
                                            <i className="pi pi-folder" />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: 600,
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() =>
                                                        window.open(file.file_url, "_blank")
                                                    }
                                                >
                                                    {file.file_name}
                                                </div>
                                            </div>
                                        </FlexComponent>

                                        <Button
                                            icon="pi pi-external-link"
                                            rounded
                                            text
                                            onClick={() =>
                                                window.open(file.file_url, "_blank")
                                            }
                                            style={{ color: "white" }}
                                        />

                                        <Button
                                            icon="pi pi-download"
                                            rounded
                                            text
                                            severity="success"           // Green color
                                            onClick={() => handleDownload(file)}
                                            tooltip="Download file"
                                        />

                                    </FlexComponent>
                                    {file.file_url && <PreviewFile previewFile={file} />}

                                </div>
                            ))
                        )}
                    </div>
                </AppModal>
            </div>
        </div>
    )
}

export default CheckList
